import { useScrollDirection } from '@utils/hooks';
import cx from 'classnames';
import { Link } from 'gatsby';
import React, { useEffect, useState } from 'react';

import * as styles from './Header.module.css';

import CategoryListing from '@components/Listing/CategoryListing';
import Modal from '@components/Modal/Modal';
import DesktopNavigation from '@components/Navigation/Desktop/Navigation';
import MobileNavigation from '@components/Navigation/Mobile/Navigation';
import Toggle from '@components/Navigation/Mobile/Toggle';
import Logo from '@components/SVG/Logo';

const Header = ({
	title,
	transparent,
	transparentBorder,
}: {
	title: string;
	transparent?: boolean;
	transparentBorder?: boolean;
}): JSX.Element => {
	const [showMobileMenu, setShowMobileMenu] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [scrollY, setScrollY] = useState(0);

	const isBrowser = typeof window !== 'undefined';

	if (!isBrowser) return null;

	const scrollDirection = useScrollDirection();

	useEffect(() => {
		setScrollY(window.pageYOffset);

		const updateScroll = () => {
			setScrollY(window.pageYOffset);
		};

		window.addEventListener('scroll', updateScroll);

		return () => {
			window.removeEventListener('scroll', updateScroll);
		};
	}, [scrollY]);

	showMobileMenu || showModal
		? setTimeout(() => document.body.classList.add('lock'), 350)
		: document.body.classList.remove('lock');

	return (
		<header
			id="header"
			className={cx(styles.header, {
				[styles.transparent]:
					window.matchMedia('(min-width: 64em)').matches &&
					transparent,
				[styles.transparentBorder]: transparentBorder,
				[styles.mobileNavOpen]: showMobileMenu,
				[styles.hide]:
					scrollY > 150 &&
					scrollDirection === 'down' &&
					!window.matchMedia('(min-width: 64em)').matches,
			})}
			role="banner">
			<div className={cx(styles.layout, 'container', 'container--grow')}>
				<Link
					to="/"
					className={styles.link}
					aria-label={`${title} logo`}>
					<Logo className={styles.logo} />
				</Link>

				<DesktopNavigation setShowModal={setShowModal} />

				<Toggle
					showMobileMenu={showMobileMenu}
					setShowMobileMenu={setShowMobileMenu}
				/>
			</div>

			<MobileNavigation
				showMobileMenu={showMobileMenu}
				setShowMobileMenu={setShowMobileMenu}
			/>

			<Modal showModal={showModal} setShowModal={setShowModal}>
				<CategoryListing theme="dark" grow />
			</Modal>
		</header>
	);
};

export default Header;
